<template>
	<div>
		<table class="v-datatable v-table theme--light">
			<thead>
				<tr>
					<th v-if="enableReorder" class="column pr-0 text-xs-left"></th>
					<th v-if="showTypeColumn" class="column text-xs-left">Type</th>
					<th v-if="showCategoryColumn" class="column text-xs-left">Category</th>
					<th class="column text-xs-left">{{ itemHeaderText }}</th>
					<th class="column text-xs-left"></th>
					<th class="column text-xs-left"></th>
				</tr>
			</thead>
			<draggable v-model="items" @start="drag=true" @end="drag=false" @change="onChange" ghost-class="ghost" handle=".handle" tag="tbody">
				<tr v-for="item in items" :key="item.id">
					<td class="pr-0" v-if="enableReorder" style="width: 1px;">
						<v-icon class="handle" title="Reorder">mdi-format-align-justify</v-icon>
					</td>
					<td v-if="showTypeColumn" class="text-xs-left">
						<v-chip small :color="getTypeChipColor(item.type)" text-color="white">{{ getTypeFriendly(item.type) }}</v-chip>						
					</td>
					<td v-if="showCategoryColumn" class="text-xs-left">{{ item.category }}</td>
					<td class="text-xs-left">
						<div class="my-2">
							{{ item.item }}

							<div class="ml-2 my-2" style="color: rgba(0,0,0,0.6)" v-if="item.outcomes != null && item.outcomes.length > 0">
								<div v-for="(outcome, index) in item.outcomes" :key="index">
									<table>
										<tr>
											<td style="width: 1px; height: inherit;" class="pa-0">
												<v-icon style="font-size: 14px;">keyboard_arrow_right</v-icon>
											</td>
											<td class="pl-3" style="height: inherit;">{{ outcome.outcome }}</td>
										</tr>
									</table>
								</div>
							</div>
						</div>			
					</td>
					<td class="text-xs-left">
						<v-tooltip bottom>
							<v-icon v-if="!item.isPerformanceReviewDiscussionPoint" small slot="activator">speaker_notes_off</v-icon>
							<span>This {{ getTypeFriendly(item.type) }} will not be discussed in performance reviews</span>
						</v-tooltip>									
					</td>
					<td class="justify-center px-0">
						<v-icon small class="mr-2" @click="editPositionItem(item)">
							edit
						</v-icon>
						<v-icon small @click="deletePositionItem(item)">
							delete
						</v-icon>
					</td>
				</tr>
			</draggable>			
		</table>
	</div>
</template>

<script>
	import typeFriendlyMixin from '@/mixins/typeFriendlyMixin';
    import draggable from 'vuedraggable';

	export default {
		props: {
			positionItems: {
				required: false,
				type: Array
			},
			showTypeColumn: {
				default: false
			},
			showCategoryColumn: {
				default: true
			},
			itemHeaderText: {
				default: 'Item'
			},
			enableReorder: {
				default: false,
				type: Boolean
			}
		},
		components: {
			draggable
		},
		data() {
			return {
				editedPositionItem: undefined,
				editedPositionItemIndex: -1,
				items: []
			};
		},
		created() {
			this.items = JSON.parse(JSON.stringify(this.positionItems));
		},
		watch: {
			positionItems() {
				this.items = JSON.parse(JSON.stringify(this.positionItems));
			}
		},
		mixins: [typeFriendlyMixin],
		methods: {
			onChange(data) {
				this.$emit('onSortOrderUpdated', this.items);
			},
			editPositionItem(item) {
				this.$emit('onEditPositionItem', item);
			},
			deletePositionItem(item) {
				this.$emit('onDeletePositionItem', item);
			}
		}
	};
</script>

<style scoped>
	.handle {
		padding-right: 8px;
    	cursor: move;
	}
	.ghost {
    	opacity: 0.5;
    	background: #c8ebfb;
    }
</style>
